var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedindark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    fill: "url(#pattern0_466_474)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_466_474",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_466_474",
    transform: "translate(-0.181818 -0.181818) scale(0.0151515)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_466_474",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAADTklEQVR4nO2cu2sUURjFb9QYEQTfmri7c87dYYOxXFBQISBYiLUWilhYiKDxP9DOB4ggKliLBkTtRFCwVQNCtBA7rQSLgGii+B65mGIJmUcSM3dm9vzgK+dj7y8fZ+7OTq4xQgghhBBCCCGEEMIEQbACwGkAYySnSEYVrSmSzwGMhGHYl+ufPgzDGoBXBZAQ5Vwv3drznORulBx1yF78yXZxUYDFRj4LwKk8RI8VYbH0W8/yED1ZgIVGnid6ctFF+14kC1ISTYmOfE+hJpr+xSk66F9qmTJ6AsBZa+2uIAi2BkGwj+RNkr98C6uMaAAvSG6arZe1dk9Zt4tFE/0xCILNKf0O+5ZWetEAzmdo2UPyjW9xpRZNcm+WngCu+xZXatEAdmQUfc63uFKLttYeyij6rm9xpRYN4EFav4GBgXUAPvsWV2rR07IPJrTrATDqW1pVRH93PxYMDw8v6+xjrd1I8o5vYZUR3VHvAdwCcNVFCsmvvmVVVXRUpZJoSnSUlwQA30i+I/kawAeSv7thoi+SvJBQN2Kue5R0HYBrM+R+AnDZfUlqt9u9Mz72EmttA8ARAI8rKdoYszSpXxiGzdmus9aeSLqu0Wj0d0gebbVa67OuwVq7m+RbiWZ20QDOmHkQhuEGFy2aaJsuGsB9swBItkh+UXQk0N/fv7JWq601C4TkFYnOgWazWQfwUzfDHJjPa25ds+uY7SmgtXY/gKPux98gCFabjMznebjpNtHtdrsXwKXpLymd+2r36PVYxjUdkOgUnOQESX+azebOtB4kt0t0ArVabQuAH0mSANwzKdTr9QGJTgDA8QyCJkwKg4ODqyQ6gZnPO+Kq0WisSct5iU4AwO0sgtxe2aQw1yd8ppt2HSQfZvwcrQy95vQeoOkm0QCeZJzobRnWJdFxSLQmeuEoOqiMpjI6Ht0MY1B0UNFBRUc8io4YFB1UdFDREY+iIwZFBxUd7OboqGoZiaZEswCTqImmf3mKDvoXq4xmRUWX9XwN/sdy/8aRh2gdMMh8Dhgc8T1R9F8nF120OwDVHYRagMVGnmp8aGho+aKLnpZd61LZ4+7Fylwkd8juc6fOuryq8g0S/9b21MVFbpMshBBCCCGEEEIIYYrNX83Gtb4rkjMzAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedindark);
export default __webpack_public_path__ + "static/media/linkedindark.9b0aca6dce866a116ebd1570a0e3a437.svg";
export { ForwardRef as ReactComponent };